// extracted by mini-css-extract-plugin
export var dataCell = "_p7-2";
export var dataRow = "_p7-0";
export var headerRow = "_p7-1";